import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PaginatorCustomService } from './paginator-custom.service';
import { PaginatorInterface } from './paginator.interface';

@Component({
  selector: 'app-paginator-custom',
  templateUrl: './paginator-custom.component.html',
  styleUrls: ['./paginator-custom.component.scss']
})
export class PaginatorCustomComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  rowSelected: number;
  valuePaginators = [1000, 2000, 3000, 4000, 5000, 6000];
  disabledSelected: boolean;
  data: PaginatorInterface = {
    page: 0,
    totalitems: 0,
    totalpages: 0,
    itemsforpage: 0
  };
  constructor(private paginatorCustomService: PaginatorCustomService) { }

  ngOnInit() {
    this.observables();
  }

  observables() {
    this.subscriptions.push(
      this.paginatorCustomService.disabledSelect$.subscribe((res: boolean) => {
        this.disabledSelected = res;
      })
    );

    this.subscriptions.push(
      this.paginatorCustomService.rowSelected$.subscribe((res: number) => {
        this.rowSelected = res ? res : 0;
      })
    );

    this.subscriptions.push(
      this.paginatorCustomService.resultService$.subscribe((res: PaginatorInterface) => {
        res ? this.data = res : this.clearData();
      })
    );
  }

  clearData() {
    this.data = {
      page: 1,
      totalitems: 0,
      totalpages: 0,
      itemsforpage: 0
    };
  }

  onChangePage(value: number) {
    this.paginatorCustomService.getQuantityByPage(value);
  }

  onPreviusPage(paginationRest: boolean) {
    !paginationRest ? this.data.page -= 1 : this.data.page = 1;
    this.paginatorCustomService.sendNumberPage(this.data.page);
  }

  onNexPage(paginationSum: boolean) {
    paginationSum ? this.data.page += 1 : this.data.page = this.data.totalpages;
    this.paginatorCustomService.sendNumberPage(this.data.page);
  }

  get titleOnpreviusPage(): string {
    return this.data.page > 1 ? 'To the page: ' + (this.data.page - 1) : '';
  }

  get titleOnNexPage(): string {
    return this.data.page < this.data.totalpages ? 'To the page: ' + (this.data.page + 1) : '';
  }

  get totalItems(): number {
    return this.data.totalitems ? this.data.totalitems : 0;
  }

  get itemsForpage(): number {
    return this.data.itemsforpage ? this.data.itemsforpage : 0;
  }

  get disabledDataPage(): boolean {
    return this.data.page === 1;
  }

  get disabledNextPage(): boolean {
    return this.data.page === this.data.totalpages;
  }

  get showPaginator(): boolean {
    return this.data.totalpages > 1;
  }

  get descriptionSelect(): string {
    return `Page: ${this.data.page} of ${this.data.totalpages}`;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/paginator-custom/paginator-custom.component.ts